import styled from "styled-components";

export default styled.div`
  display: flex;
  align-items: center;
  min-height: ${props => props.iconSize};
  text-overflow: ellipsis;
  ${props => props.hasExpandable && "cursor: pointer"};
`;
